import { ActionFunction, redirect } from 'react-router-dom';
import { Store } from 'redux';

// Sentry
import * as Sentry from '@sentry/react';

// GQL
import { formNaming } from '../../../../../components/forms/NewCommunicationForm/constants';

// Selector
import { getCurrentIndexTabFormByTab } from '../../../../../state/selectors/ui/tabs';
import { selectedOT } from '../../../../../state/selectors/ui/modal';

// Store
import { RootState } from '../../../../../state/configureStore';
import { passData } from './ActionUtils/passData';
import { saveData } from './ActionUtils/saveData';
import { tabsType } from '../../../../../state/reducers/ui/tabs';
import { indexTabFormReset } from '../../../../../state/actions/ui/tabs';
// Utils
import { getModalKeyByTab } from '../../../../../utils/getModalKeyByTab';
import { isOfflineQueuedError } from '../../../../../offline/isOfflineQueuedError';
import { communicationQueuedRedirect } from '../../communicationQueuedRedirect';
import { showSuccessToast, showBackendErrorToast } from '../../../../../utils/toasts';
import i18n from '../../../../../i18n';

function cleanupDuplicateSessionStorage() {
  sessionStorage.removeItem(formNaming.NEW_DUPLICATE_COMMUNICATION_FORM);
  sessionStorage.removeItem(formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_OT);
  sessionStorage.removeItem(formNaming.NEW_DUPLICATE_COMMUNICATION_FORM_CAMPAIGN);
}

export const ActionCommunicationDuplicateSummary: (
  store: Store<RootState>
) => ActionFunction =
  (store) =>
  async ({ request }) => {
    const formData = await request.formData();
    const intent = formData.get('intent');
    
    const tabSelected = getCurrentIndexTabFormByTab(
      tabsType.DUPLICATE_COMMUNICATION
    )(store.getState() as RootState);
    
    console.log('[ActionCommunicationDuplicateSummary] Tab selected:', tabSelected);
    
    // Get the correct modal key based on tab index
    const modalKey = getModalKeyByTab(
      formNaming.NEW_DUPLICATE_COMMUNICATION_FORM,
      tabSelected
    );
    
    console.log('[ActionCommunicationDuplicateSummary] Using modal key:', modalKey);
    
    const storedDataOTSelected = selectedOT(modalKey)(
      store.getState() as RootState
    );
    
    console.log('[ActionCommunicationDuplicateSummary] Stored OT data:', storedDataOTSelected);
    if (intent === 'pass-data') {
      try {
        return passData({
          formData,
          tabSelected,
          storedDataOTSelected,
        });
      } catch (err) {
        Sentry.captureException(err);
        console.log('Error:', err);
      }
    }

    if (intent === 'save-data') {
      // Fuera del `try` por el mismo motivo que al crear: el `catch` decide el
      // destino con él, y la limpieza ya lo habrá borrado.
      const dataFormRaw = sessionStorage.getItem(
        formNaming.NEW_DUPLICATE_COMMUNICATION_FORM
      );
      try {
        const id = formData.get('id');

        return await saveData({
          id,
          tabSelected,
          storedDataOTSelected,
          store,
        });
      } catch (err) {
        if (isOfflineQueuedError(err)) {
          showSuccessToast(i18n.t('modals:changeState.queuedOffline'));
          cleanupDuplicateSessionStorage();
          store.dispatch(indexTabFormReset(tabsType.DUPLICATE_COMMUNICATION));
          window.dispatchEvent(
            new CustomEvent('offline-communication-queued')
          );
          // Al PADRE, no al módulo (2026-09-11), igual que al crear.
          return redirect(
            communicationQueuedRedirect({
              dataFormRaw,
              tabSelected,
              storedDataOTSelected,
            }),
          );
        }
        Sentry.captureException(err);
        console.log('> CommunicationSummary - error creating:', err);
        showBackendErrorToast(err, i18n.t('toasts:error.generic'));
      }
    }
    return null;
  };
